import React from 'react';
import Icon from '../../../components/AppIcon';

const SustainabilityBenefits = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-muted/30 to-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center mb-4 px-4 py-2 rounded-full bg-primary/10 text-primary border border-primary/20">
            <Icon name="Leaf" size={20} className="mr-2" />
            <span className="text-sm font-medium">Sustentabilidade</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-foreground mb-4">
            Viva com Consciência Ambiental
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Nossos apartamentos são parte de um projeto maior de sustentabilidade, 
            onde cada morador contribui para um futuro mais verde.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="space-y-6">
            <div className="bg-card rounded-2xl p-6 border border-border shadow-warm">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
                    <Icon name="Zap" size={28} className="text-primary" />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
                    Infraestrutura Eficiente
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    Estrutura planejada para suportar operação estável e consumo consciente,
                    oferecendo mais conforto no dia a dia.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-card rounded-2xl p-6 border border-border shadow-warm">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
                    <Icon name="Recycle" size={28} className="text-primary" />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
                    Consumo Responsável
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    Processos e infraestrutura ajudam a reduzir desperdícios e manter a eficiência.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-primary/10 via-accent/10 to-primary/10 rounded-2xl p-8 border border-primary/20">
            <h3 className="text-2xl font-heading font-bold text-foreground mb-6">
              Benefícios da Infraestrutura Sustentável
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Icon name="CheckCircle" size={24} className="text-primary mt-0.5 flex-shrink-0" />
                <span className="text-foreground">Operação eficiente</span>
              </li>
              <li className="flex items-start gap-3">
                <Icon name="CheckCircle" size={24} className="text-primary mt-0.5 flex-shrink-0" />
                <span className="text-foreground">Consumo consciente</span>
              </li>
              <li className="flex items-start gap-3">
                <Icon name="CheckCircle" size={24} className="text-primary mt-0.5 flex-shrink-0" />
                <span className="text-foreground">Gestão de recursos</span>
              </li>
              <li className="flex items-start gap-3">
                <Icon name="CheckCircle" size={24} className="text-primary mt-0.5 flex-shrink-0" />
                <span className="text-foreground">Valorização do imóvel</span>
              </li>
              <li className="flex items-start gap-3">
                <Icon name="CheckCircle" size={24} className="text-primary mt-0.5 flex-shrink-0" />
                <span className="text-foreground">Contribuição para um futuro sustentável</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SustainabilityBenefits;
